import Markdown from "markdown-it";
import highlight from "highlight.js";
import 'highlight.js/styles/github.css';
const mdOptions = (Markdown.Options = {
  html:true,        // 在源码中启用 HTML 标签
  linkify: false,// 将类似 URL 的文本自动转换为链接。
  typographer: false,// 双 + 单引号替换对，当 typographer 启用时。
  breaks: true, // 转换段落里的 '\n' 到 <br>。
  langPrefix: "language-",
  // 代码高亮
  highlight(str, lang) {
    if (lang && highlight.getLanguage(lang)) {
      try {
        return (
          '<pre class="code"><code>' +
          highlight.highlight(lang, str, true).value +
          "</code></pre>"
        );
      } catch (__) {}
    }
    return "";
  },
});

export const md = new Markdown(mdOptions)

// 自定义渲染规则，去掉 <p> 标签
md.renderer.rules.paragraph_open = function () {
  return ''; // 直接返回空字符串，阻止 <p> 标签的渲染
};

md.renderer.rules.paragraph_close = function () {
  return ''; // 直接返回空字符串，阻止 </p> 标签的渲染
};

// 处理列表项
md.renderer.rules.list_item_open = function () {
  return '<li>'; // 确保 <li> 标签渲染
};

md.renderer.rules.list_item_close = function () {
  return '</li>'; // 确保 </li> 标签渲染
};

// 自定义渲染规则，仅禁用单星号解析
md.renderer.rules.em_open = (tokens, idx) => {
  if (tokens[idx].markup === '*') {
    return '*'; // 渲染为星号
  }
  return '<em>';
};

md.renderer.rules.em_close = (tokens, idx) => {
  if (tokens[idx].markup === '*') {
    return '*'; // 渲染为星号
  }
  return '</em>';
};
